import { render } from "./qzf-td.vue?vue&type=template&id=4974446b&scoped=true"
import script from "./qzf-td.vue?vue&type=script&lang=js"
export * from "./qzf-td.vue?vue&type=script&lang=js"

import "./qzf-td.vue?vue&type=style&index=0&id=4974446b&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/open-web-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4974446b"]])

export default __exports__